import { Slice, Fragment, findWrapping, ReplaceAroundStep, getChildNodeIndex, getParentPosByChild, } from '@tencent/exeditor3-core';
import { getIsSameListSameItem, joinSameListInSelection, getNodeInfosInSelection, } from './listMethods.js';
// 选区为不为空，只改变选取内的 list 部分
const changeListInSelection = (tr, listItem, listItemPos, otherList, nodeType, itemNodeType, extAttrs) => {
    const atStart = otherList.firstChild === listItem;
    const atEnd = otherList.lastChild === listItem;
    tr.step(new ReplaceAroundStep(listItemPos - (atStart ? 1 : 0), listItemPos + listItem.nodeSize + (atEnd ? 1 : 0), listItemPos + 1, listItemPos + listItem.nodeSize - 1, new Slice((atStart
        ? Fragment.empty
        : Fragment.from(otherList.copy(Fragment.empty)))
        .append(Fragment.from(nodeType.create({ ...extAttrs }, itemNodeType.create())))
        .append(atEnd
        ? Fragment.empty
        : Fragment.from(otherList.copy(Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 2 : 3));
};
// 选取为空 list 类型整体切换
const changeWholeList = (tr, otherList, otherListPos, nodeType, extAttrs) => {
    tr.step(new ReplaceAroundStep(otherListPos, otherListPos + otherList.nodeSize, otherListPos + 1, otherListPos + otherList.nodeSize - 1, new Slice(Fragment.from(nodeType.create({ ...extAttrs })), 0, 0), 1));
};
// 添加 ol 或 ul 的包裹
export const wrapList = (listItemsInfo, tr, nodeType, itemNodeType, extAttrs = {}) => {
    listItemsInfo.forEach(({ type, oldPos }) => {
        const listItemPos = tr.mapping.map(oldPos);
        switch (type) {
            case 2 /* POIType.OtherListOtherItem */:
            case 1 /* POIType.OtherListSameItem */: {
                const { from, to } = tr.selection;
                // 当前深度的父节点
                const otherList = tr.doc.resolve(listItemPos).node();
                const listItem = tr.doc.resolve(listItemPos + 1).node();
                const listItemIndex = getChildNodeIndex(listItem, otherList);
                const otherListPos = getParentPosByChild(listItemPos, listItemIndex, otherList);
                if (from === to && type === 1 /* POIType.OtherListSameItem */) {
                    changeWholeList(tr, otherList, otherListPos, nodeType, extAttrs);
                }
                else {
                    changeListInSelection(tr, listItem, listItemPos, otherList, nodeType, itemNodeType, extAttrs);
                }
                break;
            }
            case 0 /* POIType.SameListSameItem */: {
                // 当前深度的父节点
                const sameList = tr.doc.resolve(listItemPos).node();
                const listItem = tr.doc.resolve(listItemPos + 1).node();
                changeListInSelection(tr, listItem, listItemPos, sameList, nodeType, itemNodeType, extAttrs);
                break;
            }
            case 3 /* POIType.BareTextBlock */: {
                const doWrap = (pos, tryClean = false) => {
                    const $nodePos = tr.doc.resolve(pos + 1);
                    const nodeRange = $nodePos.blockRange();
                    const wrappers = findWrapping(nodeRange, nodeType);
                    if (wrappers) {
                        wrappers[0].attrs = extAttrs;
                        const [{ attrs, ...rest }, ...restNodes] = wrappers;
                        const listWrapper = {
                            ...rest,
                            attrs: {
                                ...attrs,
                                ...extAttrs,
                            },
                        };
                        tr.wrap(nodeRange, [listWrapper, ...restNodes]);
                    }
                    else if (tryClean) {
                        tr.setNodeMarkup(pos, nodeType.schema.nodes.paragraph, $nodePos.node().attrs);
                        doWrap(pos);
                    }
                };
                doWrap(listItemPos, true);
                break;
            }
            default: {
                break;
            }
        }
    });
    joinSameListInSelection(tr);
};
// 去掉 ol 或 ul 的包裹
const unwrapList = (listItemsInfo, tr) => {
    listItemsInfo.reverse().forEach(({ oldPos }) => {
        const pos = tr.mapping.map(oldPos);
        const list = tr.doc.resolve(pos).node();
        const listItem = tr.doc.resolve(pos + 1).node();
        const atStart = list.firstChild === listItem;
        const atEnd = list.lastChild === listItem;
        tr.step(new ReplaceAroundStep(pos - (atStart ? 1 : 0), pos + listItem.nodeSize + (atEnd ? 1 : 0), pos + 1, pos + listItem.nodeSize - 1, new Slice((atStart
            ? Fragment.empty
            : Fragment.from(list.copy(Fragment.empty))).append(atEnd ? Fragment.empty : Fragment.from(list.copy(Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    });
};
export const toggleList = (nodeType, itemNodeType, extAttrs) => (state, dispatch) => {
    const { tr } = state;
    // 获取选区内的 listItem 、纯文本节点信息
    const nodesInfo = getNodeInfosInSelection(state, nodeType, itemNodeType);
    if (!nodesInfo.length) {
        return false;
    }
    const isSameListSameItem = getIsSameListSameItem(nodesInfo);
    if (isSameListSameItem) {
        // 都是同种 list ，则删除 list 元素包裹
        unwrapList(nodesInfo, tr);
    }
    else {
        // 不同种 list ，则改变为相应的 nodeType 类型，或者改变 list-style-type 类型
        wrapList(nodesInfo, tr, nodeType, itemNodeType, extAttrs);
    }
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
    return true;
};
//# sourceMappingURL=toggle.js.map